import { GLServiceBase, customErrMsgs } from 'gl-commonui'
import { injectable } from '../../../util/di'
import { IProductService, ProductRequest, ProductResponse } from './index';

@injectable()
export class ProductService extends GLServiceBase<ProductRequest, any> implements IProductService {
    serviceRoute = { prefix: 'admin/v1/products' }
}